import React, { useEffect, useState } from "react";
import ModalTags from "../ModalTags";
import { DEMO_POSTS_VIDEO } from "data/posts";
import { DEMO_CATEGORIES, DEMO_TAGS } from "data/taxonomies";
import twFocusClass from "utils/twFocusClass";
import Card10V2 from "components/Card10/Card10V2";
import "../../../styles/styles.css"
import Layout from "../../(others)/layout"

const totalParPage = 6;

const PageArchiveVideo = () => {
    // Données à paginer
    const [data, setData] = useState([]);

    // État pour suivre la page actuelle
    const [currentPage, setCurrentPage] = useState(1);

    // Fonction pour charger les données paginées
    const loadData = (page:any,liste:any) => {
    // Simuler une requête à une API pour obtenir les données de la page spécifiée

    const newData: any = [];
    let count: number = 0;
    let compteur:number =0;
    let i:number = 0;
    while(count < totalParPage && compteur < liste.length-1 || count==0 )
    {
        compteur = (page-1)*totalParPage+i;
        newData[compteur] = liste.at(compteur);
        count++;i++;
    }
    // Mettre à jour les données avec les nouvelles données chargées
    setData(newData);
  };
  
  // Fonction pour passer à la page en parametre
  const gotoPage = (i:number) => {
    setCurrentPage(i);
    loadData(i,searchVideo(DEMO_POSTS_VIDEO,categorie));
  };

  useEffect(() => {
    loadData(currentPage,searchVideo(DEMO_POSTS_VIDEO,categorie));
  }, []);

  let categorie = window.location.pathname.replace("/videos/","");

  function afficherNombreVideo(liste:any,cat:any) 
  {
    if (cat==="/videos" || cat=="/")
      return liste.length;
    let arr:any = [];
    liste.forEach(function(video:any)
    {
      if(video.categories[0].name.toLowerCase().replace("é","e") === cat) 
      {
        arr.push(video);
      }
    })

    return arr.length;
  }

  function searchVideo(liste:any,cat:any) 
  {
    if (cat==="/videos" || cat=="/")
      return liste;
    let arr:any = [];
    liste.forEach(function(video:any)
    {
      if(video.categories[0].name.toLowerCase().replace("é","e") === cat) 
      {
        arr.push(video);
      }
    })

    return arr;
  }

  function afficherCategorie()
  {
    let composant = <></>
    if (!categorie.endsWith("videos") && categorie != "/")
      composant =  <h3 className="inline-block align-bottom text-1xl font-semibold md:text-3xl "> - { categorie }</h3> 
    return composant;
  }
  
  function getPagesNumbers() 
  {
    let content = [];
    let totalPages = Math.ceil(afficherNombreVideo(DEMO_POSTS_VIDEO,categorie)/totalParPage);

    for (let i:number=1;i<=totalPages;i++) 
    {
      if (i==currentPage)
        content.push(<button key = {i} className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-primary-6000 text-white ${twFocusClass()}`}>{i}</button>);  
      else
        content.push(<button key = {i} onClick={() => gotoPage(i)} className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-white hover:bg-neutral-100 border border-neutral-200 text-neutral-6000 dark:text-neutral-400 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:border-neutral-700 ${twFocusClass()}`}>{i}</button>);
    }
    return content;
  }

  return (
    <Layout>
      
          {/* HEADER */}
          <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl ">
            Vidéos&nbsp;
          </h2>
          {afficherCategorie()}
          <span className="block text-neutral-300">{afficherNombreVideo(DEMO_POSTS_VIDEO,categorie)} vidéos</span>
          {/* ====================== END HEADER ====================== */}
          <div className="mt-6 flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <div className="flex space-x-2.5">
              <ModalTags tags={DEMO_TAGS} />
            </div>
            <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
            <div className="flex justify-end">
            </div>
          </div>
          {/* LOOP ITEMS */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 md:gap-x-8 md:gap-y-10 mt-8 lg:mt-10">
            {
            data.map((post:any) => (
              <Card10V2 key={post.id} post={post} />  
            ))
            }
          </div>
          <br/>
          {getPagesNumbers()}
  
      </Layout>
  );  
};

export default PageArchiveVideo;
